import * as React from "react";
import TextAction, { TextActionProps } from "./TextAction";

export default function HideAction(props: TextActionProps) {
  return <TextAction {...props} icon={<i className="ic_eye_closed" />} label={props.label || i18n["Global.Hide"]} />;
}
